module.exports = __webpack_public_path__ + "img/logo-vsauce.d3a159e6.png";